import { IPushNotification } from 'APP/store/PushNotifications/PushNotifications.types';
import Entities from 'STORE';

export const alreadyReadMessage = (pushNotification: IPushNotification): boolean => {
  if (!pushNotification.group) {
    return false;
  }

  if (!pushNotification.messageId) {
    return false;
  }

  const group = Entities.GroupsStore.getGroupById(pushNotification.group);
  const message = group?.messagesStore.getMessageById(pushNotification.messageId);

  return message ? !message.unread : false;
};
